import { render, staticRenderFns } from "./SuppControlInfo.vue?vue&type=template&id=c20cbd90&"
import script from "./SuppControlInfo.vue?vue&type=script&lang=js&"
export * from "./SuppControlInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports